function escapeHtml(s) {
  return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

function inline(text) {
  let html = escapeHtml(text);
  html = html.replace(/!\[([^\]]*)\]\(([^)]+)\)/g, '<img src="$2" alt="$1" loading="lazy" class="blog-content-img" />');
  html = html.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>');
  html = html.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
  html = html.replace(/\*([^*]+)\*/g, '<em>$1</em>');
  return html;
}

// Renders the Markdown subset produced by the blog admin editor
// (headings, bold/italic, links, images, lists, blockquotes, dividers, paragraphs).
export function renderMarkdown(md) {
  if (!md) return '';
  const lines = String(md).replace(/\r\n/g, '\n').split('\n');
  const out = [];
  let i = 0;
  let paragraph = [];

  const flushParagraph = () => {
    if (paragraph.length) {
      out.push(`<p>${inline(paragraph.join(' '))}</p>`);
      paragraph = [];
    }
  };

  while (i < lines.length) {
    const line = lines[i];
    let m;

    if (/^\s*$/.test(line)) { flushParagraph(); i++; continue; }
    if (/^---+\s*$/.test(line)) { flushParagraph(); out.push('<hr />'); i++; continue; }

    if ((m = line.match(/^####\s+(.+)$/))) { flushParagraph(); out.push(`<h4>${inline(m[1])}</h4>`); i++; continue; }
    if ((m = line.match(/^###\s+(.+)$/)))  { flushParagraph(); out.push(`<h3>${inline(m[1])}</h3>`); i++; continue; }
    if ((m = line.match(/^##\s+(.+)$/)))   { flushParagraph(); out.push(`<h2>${inline(m[1])}</h2>`); i++; continue; }
    if ((m = line.match(/^#\s+(.+)$/)))    { flushParagraph(); out.push(`<h1>${inline(m[1])}</h1>`); i++; continue; }

    if (/^>\s?/.test(line)) {
      flushParagraph();
      const buf = [];
      while (i < lines.length && /^>\s?/.test(lines[i])) { buf.push(lines[i].replace(/^>\s?/, '')); i++; }
      out.push(`<blockquote>${inline(buf.join(' '))}</blockquote>`);
      continue;
    }

    if (/^-\s+/.test(line)) {
      flushParagraph();
      const items = [];
      while (i < lines.length && /^-\s+/.test(lines[i])) { items.push(`<li>${inline(lines[i].replace(/^-\s+/, ''))}</li>`); i++; }
      out.push(`<ul>${items.join('')}</ul>`);
      continue;
    }

    if (/^\d+\.\s+/.test(line)) {
      flushParagraph();
      const items = [];
      while (i < lines.length && /^\d+\.\s+/.test(lines[i])) { items.push(`<li>${inline(lines[i].replace(/^\d+\.\s+/, ''))}</li>`); i++; }
      out.push(`<ol>${items.join('')}</ol>`);
      continue;
    }

    if (/^!\[[^\]]*\]\([^)]+\)\s*$/.test(line.trim())) {
      flushParagraph();
      out.push(inline(line.trim()));
      i++;
      continue;
    }

    paragraph.push(line);
    i++;
  }
  flushParagraph();
  return out.join('\n');
}

// Plain-text excerpt for cards/meta descriptions — strips markdown syntax.
export function excerpt(md, maxLen = 160) {
  if (!md) return '';
  const text = String(md)
    .replace(/!\[[^\]]*\]\([^)]+\)/g, '')
    .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')
    .replace(/[#>*_-]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
  return text.length > maxLen ? text.slice(0, maxLen).trim() + '…' : text;
}
